import type { Question } from "@/schema/quizSchema";

type TextQuestion = Extract<Question, { type: "text" }>;

export function TextInput({
  question,
  value,
  onAnswer,
}: {
  question: TextQuestion;
  value: string | undefined;
  onAnswer: (value: string) => void;
}) {
  return (
    <div>
      <label className="qk-prompt">{question.prompt}</label>
      <input
        type="text"
        className="qk-field"
        aria-label={question.prompt}
        placeholder={question.placeholder}
        // Controlled: QuizWidget stages the draft into reducer state (same-id dispatch)
        // and feeds it back as `value`, so text accumulates across keystrokes. (Unit
        // tests must drive this through a stateful harness, not a static spy.)
        value={value ?? ""}
        onChange={(e) => onAnswer(e.target.value)}
      />
    </div>
  );
}
